<template>
    <div class="webchat-container" :class="{ minimized: isMinimized }">
      <div class="webchat-header" @click="toggleMinimize">
        <span>Chat</span>
        <i v-if="isMinimized">+</i>
        <i v-else>_</i>
      </div>
      <div class="webchat-content">
        <router-view></router-view>
    <!-- Adicione aqui o conteúdo do seu chat -->
      </div>
    </div>
  </template>
<script>

export default {
components: {},
  data() {
    return {
      isMinimized: false,
    };
  },
  methods: {
    toggleMinimize() {
      this.isMinimized = !this.isMinimized;
    },
  },
};
</script>
<style>
.webchat-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 300px;
  height: 400px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.webchat-header {
  background-color: #2196f3;
  color: #fff;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.minimized {
  height: 0;
  transition: height 0.3s;
}

.webchat-content {
  flex: 1;
  overflow-y: auto;
}

</style>
  